import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Bento from "@/components/landing/Bento";
import Calculator from "@/components/landing/Calculator";
import HowItWorks from "@/components/landing/HowItWorks";
import Footer from "@/components/landing/Footer";
import AuthModal from "@/components/AuthModal";
import { useAuth } from "@/lib/auth";

export default function Landing() {
  const [gateOpen, setGateOpen] = useState(false);
  const { authed } = useAuth();
  const navigate = useNavigate();

  const launch = () => {
    if (authed) navigate("/app");
    else setGateOpen(true);
  };

  return (
    <div className="min-h-screen bg-ink text-hi overflow-x-clip">
      <Nav onLaunch={launch} />
      <Hero onLaunch={launch} />
      <Marquee />
      <Bento />
      <Calculator />
      <HowItWorks onLaunch={launch} />
      <Footer />
      <AuthModal open={gateOpen} onClose={() => setGateOpen(false)} />
    </div>
  );
}
